<template>
  <div class="content">
    <transition :name="transitionName" mode="out-in">
      <div class="survey-wrapper" :key="currentQuestion.id" v-cloak v-if="!isComplete">

        <div class="survey-body">
          <div class="survey-title">
            <h3>{{currentQuestion.title}}</h3>
          </div>
          <div class="survey-img">
            <img :src="currentQuestion.pic_url" />
          </div>
          <!-- 文本框填写 -->
          <div class="survey-answer" v-if="currentQuestion && currentQuestion.type=='3'">
            <input type="text" class="answer-text" maxlength="100" autocomplete="off" placeholder="请填写"
              v-model="currentQuestion.textResult"></input>
          </div>
          <!-- 选项 -->
          <div class="survey-options" v-else>
            <ul :class="{'twoitem':currentQuestion.options_per_line==2}">
              <li v-for="(option,i) in currentQuestion.options" @click="selectOption(option)">
                <div :class="{'selected':option.selected}">{{option.option_text}}</div>
              </li>
            </ul>
          </div>

        </div>

        <div class="survey-progress">
          <span class="progress-label">答题进度</span>
          <div class="progress-bar-wrap">
            <van-progress :percentage="progress" stroke-width="8" v-if="progress>=0" />
          </div>
        </div>
        <div class="footer">
          <div class="left-btn">
            <van-button round type="default" @click="goPrevious()" style="width:100%" :disabled="isFirstQuestion">上一题
            </van-button>
            <!-- <van-icon name="arrow-left" size="24" @click="goPrevious()" style="padding:10px" v-if="!isFirstQuestion" /> -->
          </div>
          <div style="flex:1">
          </div>
          <div class="right-btn">
            <van-button round type="info" @click="goNext()" style="width:100%">下一题</van-button>
          </div>
        </div>
      </div>
      <div class="survey-complete" v-else>
        <!-- <van-icon name="passed" size="48" color="#07c160" /> -->
        <img src="@/assets/images/img-complete.png" width="200px" />
        <p class="complete-text">已填写完毕，请点击下方按钮提交</p>
        <div class="remark-text" v-if="surveyInfo.remark && surveyInfo.remark !=''">
          {{surveyInfo.remark}}
        </div>
        <van-button type="info" size="large" @click="commitSurvey()">提交问卷</van-button>
      </div>
    </transition>
  </div>
</template>

<style lang="less" scoped>
  html body {
    height: 100%;
  }

  .content {
    height: 100vh;
  }

  .survey-wrapper {
    height: 100%;

    display: flex;
    flex-flow: column;

    .survey-progress {
      background-color: #fff;
      padding: 12px;
      display: flex;

      .progress-label {
        line-height: 13px;
        font-size: 12px;
        margin-right: 10px;
      }

      .progress-bar-wrap {
        flex: 1;
        padding: 2px;
      }
    }

    .survey-body {
      overflow-x: hidden;
      overflow-y: auto;
      padding: 16px;
      background: #ffffff;
      flex-grow: 1;
      font-size: 16px;

      h3 {
        font-size: 20px;
        line-height: 32px;
      }

      .survey-img {
        text-align: center;

        img {
          max-width: 100%;
          max-height: 240px;
        }
      }

      .survey-options {
        width: 100%;

        li {
          margin-bottom: 24px;
          cursor: pointer;

          div {
            text-align: center;
            display: block;
            background-color: #eeeeee;
            margin-bottom: 20px;
            border-radius: 22px;
            padding: 8px;
            margin: 0 8px;
          }

          .selected {
            color: #fff;
            background-color: var(--color-main);
          }
        }

        .twoitem {
          li {
            width: 50%;
            word-break: break-all !important;
            line-height: 20px !important;
            text-align: center;
            border-radius: 20px;
            display: inline-block;
            font-size: 16px;
          }
        }
      }

      .survey-answer {
        height: 36px;
        // border: 2px solid #c4c7ce;
        border: 2px solid var(--color-main);
        border-radius: 8px;
        overflow: visible;

        .answer-text {
          border: 0;
          padding: 4px 8px;
          line-height: 28px;
          width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          margin: 0 8px;
          -webkit-border-radius: 0;
          border-radius: 0;
          resize: none;
        }
      }
    }

    .footer {
      background-color: #fff;
      display: flex;
      justify-items: center;
      padding: 0px 12px 12px 12px;

      .van-button {
        height: 36px;
      }

      .left-btn {
        width: 150px;
      }

      .right-btn {
        width: 150px;
      }
    }
  }

  .survey-complete {
    text-align: center;
    background: #ffffff;
    height: 100%;
    margin: auto 0;
    padding: 48px 24px;

    .complete-text {
      margin: 16px 0 48px;
      font-size: 18px;
    }

    .remark-text {
      background-color: #fffbe8;
      color: #ed6a0c;
      font-size: 14px;
      text-align: left;
      padding: 8px;
      margin-bottom: 24px;
    }
  }
</style>

<script>
  import Vue from "vue";
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'
  import {
    Progress,
    Toast
  } from "vant";
  Vue.use(Progress);

  import * as survey_api from '@/api/survey.js';
  import {
    getAge,
    getAgeFromBirth
  } from "@/libs/validate-utils";
  export default {
    data() {
      return {
        transitionName: "slide-left",
        userProfile: {
          sex: "male",
          age: 40,
          marriage: "已婚"
        },
        surveyInfo: {
          questions: []
        },
        currentQuestion: Object,
        isComplete: false,
        surveyResult: []
      };
    },
    computed: {
      progress() {
        if (!this.surveyInfo || !this.surveyInfo.questions || this.surveyInfo.questions.length == 0 || !this
          .currentQuestion) {
          return 0;
        } else {
          var total = this.surveyInfo.questions.length;
          var index = this.surveyInfo.questions.indexOf(this.currentQuestion);
          return parseInt((index / total) * 100);
        }
      },
      isFirstQuestion() {
        if (!this.surveyInfo || !this.surveyInfo.questions || this.surveyInfo.questions.length == 0 || !this
          .currentQuestion) {
          return true;
        }
        var index = this.surveyInfo.questions.indexOf(this.currentQuestion);
        return index == 0;
      },
      ...mapState({
        activeUserProfile: state => state.user.activeUserProfile
      })
    },
    created() {
      let hospid = this.$route.query.hospid;
      let surveyId = this.$route.query.surveyId;
      survey_api.getSurveyDetail(hospid, surveyId).then(res => {
        console.log(res);
        if (res.code == 200) {
          let survey = res.data;
          if (survey.questions && survey.questions.length > 0) {
            survey.questions.forEach(q => q.textResult = '');
          }
          this.surveyInfo = survey;
          this.currentQuestion = this.surveyInfo.questions[0];
        }
      })
    },
    mounted() {
      if (!this.activeUserProfile) {
        this.$router.push("/");
      } else {
        this.userProfile.sex = this.activeUserProfile.sex == 1 ? 'male' : 'female';
        this.userProfile.age = getAgeFromBirth(this.activeUserProfile.birth);
        //this.userProfile.marriage
      }
    },
    methods: {
      ...mapActions("user", {
        setActiveUserProfile: "setActiveUserProfile"
      }),
      selectOption(option) {
        //如果是单选题或者选中排它项
        if (this.currentQuestion.type == '1' || option.exclusion_flag == true) {
          option.selected = true;
          for (let index = 0; index < this.currentQuestion.options.length; index++) {
            const op = this.currentQuestion.options[index];
            if (op != option) {
              op.selected = false;
            }
          }
          this.$set(this.currentQuestion.options, this.currentQuestion.options.indexOf(option), option);
          //自动跳转到下一题
          if (this.currentQuestion.options.find(o => o.selected)) {
            this.$nextTick(function () {
              this.goNext();
            });
          }
        } else if (this.currentQuestion.type == '2') {
          //取消选中排它项
          for (let index = 0; index < this.currentQuestion.options.length; index++) {
            const op = this.currentQuestion.options[index];
            if (op.exclusion_flag) {
              op.selected = false;
              this.$set(this.currentQuestion.options, this.currentQuestion.options.indexOf(op), op);
            }
          }

          option.selected = !option.selected;
          this.$set(this.currentQuestion.options, this.currentQuestion.options.indexOf(option), option);
        }

      },
      goPrevious() {
        this.transitionName = "slide-right";
        let previosIndex = this.surveyResult.length - 1;
        if (previosIndex < 0) {
          return
        }
        let preResult = this.surveyResult[previosIndex];

        if (preResult && preResult.id) {
          let question = this.surveyInfo.questions.find(q => q.id == preResult.id);
          this.currentQuestion = question;
        }
        //后退时删除最后一行元素
        this.surveyResult.pop();
      },
      goNext() {
        this.transitionName = "slide-left";
        if (!this.setActiveResult())
          return;
        let index = this.surveyInfo.questions.indexOf(this.currentQuestion);
        if (index == this.surveyInfo.questions.length - 1) {
          this.isComplete = true;
        } else {
          let flag = false;
          let nextIndex = index + 1;
          while (!flag) {
            if (nextIndex >= this.surveyInfo.questions.length) {
              flag = true;
              this.isComplete = true;
            } else {
              let nextQuestion = this.surveyInfo.questions[nextIndex];
              if (this.isMatchRule(nextQuestion)) {
                flag = true;
                this.currentQuestion = nextQuestion;
              } else {
                nextIndex++;
              }
            }
          }
          // this.currentQuestion = this.surveyInfo.questions[index + 1];
          // this.isMatchRule(this.currentQuestion);
        }
      },
      //设置当前问题的选项结果
      setActiveResult() {
        //判断是否必填
        if (this.currentQuestion.required) {
          if (this.currentQuestion.type == '3') {
            if (!this.currentQuestion.textResult || this.currentQuestion.textResult == '') {
              this.$toast.fail("此题目需要填写信息");
              return false;
            }
          } else if (this.currentQuestion.options.findIndex(it => {
              return it.selected
            }) < 0) {
            console.log(this.currentQuestion.options);
            this.$toast.fail("请选择相应的选项。");
            return false;
          }

        }

        //先清除之前的数据
        let index = this.surveyResult.findIndex(i => i.id == this.currentQuestion.id);
        if (index >= 0) {
          this.surveyResult.splice(index, 1);
        }
        let questionResult = {
          id: this.currentQuestion.id,
          title: this.currentQuestion.title,
          options: [],
          type: this.currentQuestion.type,
          textResult: this.currentQuestion.textResult,
        };
        this.currentQuestion.options.forEach(item => {
          if (item.selected) {
            questionResult.options.push({
              option_text: item.option_text,
              option_value: item.option_value,
              unnormal_flag: item.unnormal_flag,
            })
          }
        });
        this.surveyResult.push(questionResult);
        return true;
      },
      //是否匹配题目规则
      isMatchRule(question) {
        if (question.match_rule) {
          let rules = JSON.parse(question.match_rule);
          console.log(rules);
          return this.convertExpression(rules);
        } else {
          return true;
        }
      },
      getMatchRules() {
        var ruleIds = [];
        for (let index = 0; index < this.surveyInfo.rules.length; index++) {
          const ruleItem = this.surveyInfo.rules[index];
          if (ruleItem.expression && ruleItem.expression != "") {
            let ruleObj = JSON.parse(ruleItem.expression);
            if (this.convertExpression(ruleObj)) {
              ruleIds.push(ruleItem.id);
            }
          }
        }
        return ruleIds;
      },
      convertExpression(rules) {
        if (rules.children && rules.children.length > 0) {
          var boolResults = []
          rules.children.forEach(rule => {
            boolResults.push(this.parseRule(rule).toString());
          });
          var logicStr = "";
          if (rules.logicalOperator == 'all') {
            logicStr = boolResults.join(" && ");
          } else {
            logicStr = boolResults.join(" || ");
          }

          console.log(logicStr);
          return eval(logicStr);
        } else {
          return false;
        }
      },
      parseRule(rule) {
        console.log(rule);
        if (rule.type == "query-builder-rule") {
          let queryStr = "";
          if (rule.query.rule == "sex") {
            queryStr = queryStr + "'" + this.userProfile.sex + "'";
          } else if (rule.query.rule == "age") {
            queryStr = queryStr + this.userProfile.age.toString();
          } else if (rule.query.rule == "marrital") {
            queryStr = queryStr + "'" + this.userProfile.marriage + "'";
          } else {
            if (isNaN(rule.query.rule)) {
              return false;
            } else {
              let qid = parseInt(rule.query.rule);
              let item = this.surveyResult.find(i => i.id == qid);
              if (item && item.options && item.options.length > 0) {
                //多选题目的逻辑计算
                if (Array.isArray(rule.query.value)) {
                  //判断是否存在交集
                  var interset = rule.query.value.filter(v => item.options.findIndex(i => i.option_value == v) >= 0);
                  if (interset && interset.length > 0) {
                    return true;
                  } else {
                    return false;
                  }
                } else {
                  queryStr = queryStr + "'" + item.options[0].option_value + "'";
                }
              } else {
                return false;
              }
            }
          }

          switch (rule.query.operator) {
            case "等于":
              queryStr += " == "
              break;
            case "不等于":
              queryStr += " != "
              break
            case "大于":
              queryStr += " > "
              break;
            case "大于或等于":
              queryStr += " >= "
              break;
            case "小于":
              queryStr += " < "
              break
            case "小于或等于":
              queryStr += " <= "
            default:
              break;
          }

          if (rule.query.rule == 'age') {
            queryStr += rule.query.value;
          } else {
            queryStr += "'" + rule.query.value + "'";
          }

          console.log(queryStr);

          return eval(queryStr);

          //{rule: "sex", operator: "等于", operand: "性别", value: "female"}
        } else {
          return this.convertExpression(rule);
        }
      },
      commitSurvey() {

        this.$toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '正在提交',
        });
        let surveydata = {
          id: 0,
          hosp_id: this.surveyInfo.hosp_id,
          survey_id: this.surveyInfo.id,
          account_id: this.activeUserProfile.account_id,
          profile_id: this.activeUserProfile.id,
          unnormal_flag: false,
          recommended_package: "",
          recommended_combo: "",
          recommended_item: "",
          filter_package: "",
          filter_combo: "",
          filter_item: "",
          name: this.activeUserProfile.name,
          jlzt: 0,
          survey_result: []
        }
        this.surveyResult.forEach(item => {
          //文本框题目
          if (item.type == '3') {
            surveydata.survey_result.push({
              question_id: item.id,
              question_title: item.title,
              option_value: '',
              option_text: item.textResult,
              unnormal_flag: false, //todo
            })
          } else {
            surveydata.survey_result.push({
              question_id: item.id,
              question_title: item.title,
              option_value: item.options.map(i => {
                return i.option_value
              }).join(","),
              option_text: item.options.map(i => {
                return i.option_text
              }).join(","),
              unnormal_flag: item.options.findIndex(i => i.unnormal_flag == true) >= 0, //todo
            })
          }
        });
        surveydata.matchRuleIds = this.getMatchRules();
        console.log(surveydata);
        survey_api.saveUserSurvey(surveydata).then(res => {
          console.log(res);
          if (res.code == 200) {
            //跳转到个人预约界面
            if (this.$route.query.from == 'personal') {
              this.$router.push({
                path: "/submitOrder"
              });
              return;
            }
            //将推荐的方案存入sessionStorage
            if (res.data.projects)
              sessionStorage.setItem("customizedProjects", JSON.stringify(res.data.projects));
            if (res.data.suggestions)
              sessionStorage.setItem("suggestions", JSON.stringify(res.data.suggestions));
            if (this.surveyInfo.survey_type == 0) {
              this.$router.push("recommend");
            } else {
              this.$router.push("success");
            }
          } else {
            this.$Toast.fail("提交问卷出现异常");
            console.log(res.msg);
          }
        }).catch(err => {
          console.log(err)
        }).finally(() => {
          this.$Toast.clear();
        });

      }
    }
  };
</script>